import { createLogicMiddleware } from 'redux-logic';

import logic from '~logic';

export default createLogicMiddleware(logic);
